// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../../../routes/paths';
// components
// import Label from '../../../components/Label';
// import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
      // { title: 'app', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      // { title: 'ecommerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      // { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      // { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
  //   ],
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // USER
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          // { title: 'profile', path: PATH_DASHBOARD.user.profile },
          // { title: 'cards', path: PATH_DASHBOARD.user.cards },
          { title: 'list', path: PATH_DASHBOARD.user.list },
          // { title: 'create', path: PATH_DASHBOARD.user.new },
          // { title: 'edit', path: PATH_DASHBOARD.user.demoEdit },
          // { title: 'account', path: PATH_DASHBOARD.user.account },
        ],
      },
      // INVOICE
      {
        title: 'club',
        path: PATH_DASHBOARD.club.root,
        icon: ICONS.dashboard,
        children: [
          { title: 'list', path: PATH_DASHBOARD.club.list },
          // { title: 'details', path: PATH_DASHBOARD.club.demoView },
          { title: 'create', path: PATH_DASHBOARD.club.new },
          // { title: 'edit', path: PATH_DASHBOARD.club.demoEdit },
        ],
      },
      {
        title: 'Settings',
        path: PATH_DASHBOARD.settings.edit,
        icon: ICONS.dashboard,
      },
    ],
  },
  
  // CMS
  {
    subheader: 'CMS',
    items: [
      {
        title: 'CMS',
        path: PATH_PAGE.faqs,
        icon: ICONS.dashboard,
        children: [
          {
            title: 'FAQs',
            path: PATH_PAGE.faqs,
            // icon: ICONS.mail,
            // info: <Label color="error">+32</Label>,
          },
          { title: 'Privacy Policy', path: PATH_PAGE.privacyPolicy  },
          { title: 'Community Guideline', path: PATH_PAGE.communityGuideline  },
    
        ],
      },

    ],
  },
];

export default navConfig;
